export const colorAreaCSSVars = {
    areaXProgressVar: `--fui-AreaX--progress`,
    areaYProgressVar: `--fui-AreaY--progress`,
    thumbColorVar: `--fui-Area__thumb--color`,
    mainColorVar: `--fui-Area--main-color`
};
